import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map, of, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { InterceptorSkipHeader } from './auth-interceptor.service';
import { Router } from '@angular/router';
import { LocalStorageService } from './local-storage.service';

export interface Auth {
  email: string;
  password: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private readonly _http: HttpClient,
    private readonly router: Router,
    private readonly _storage: LocalStorageService
  ) {}

  login(auth: Auth): Observable<any> {
    return this._http.post<any>(`${environment.api}/login`, auth, {
      headers: new HttpHeaders().set(InterceptorSkipHeader, '')
    });
  }

  logout(): Observable<any> {
    this._http.post<any>(`${environment.api}/logout`, {}).subscribe(() => {
      this.router.navigate(['public/login']).then();
    });

    return of(null);
  }

 
  refresh(): Observable<any> {
    const refreshToken = this._storage.get('refresh_token') as string | null;
    if (!refreshToken) {
      return throwError(() => new Error('No refresh token available'));
    }

    const connectionId = (this._storage.get('connection') as string | null) ?? '';

    return this._http.post<any>(`${environment.api}/refresh`, {}, {
      headers: new HttpHeaders()
        .set(InterceptorSkipHeader, '')
        .set('Authorization', `Bearer ${refreshToken}`)
        .set('connection-id', connectionId)
    });
  }

  isAuthenticated(): Observable<any> {
    return this._http.get<any>(`${environment.api}/validateToken`)
      .pipe(map(res => res.success));
  }
}
